import { Component, Input, OnInit } from '@angular/core';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../shared/formly/ga-formly.service';
import { IUploadContext } from './upload-data.service';
import { UntypedFormGroup } from '@angular/forms';
import { UPLOAD_STEP3, UPLOAD_WIZARD, UploadService } from './upload.service';
import * as _ from 'underscore';
import { AuthService } from '../../shared/services/auth/auth.service';
import { GaWizard } from '../../shared/wizard/ga-wizard';
import { GaWizardService } from '../../shared/wizard/ga-wizard.service';

@Component({
  selector: 'uploads-step-two',
  template: `
    <div class="uploads-step-two">
      <p [innerHTML]="('GA.UPLOADS.UPLOAD_INFO' | translate)"></p>
      
      <p>
        <upload-example-template [code]="code"></upload-example-template>
      </p>

      <div class="form-horizontal">
        <formly [form]="form" [model]="model" [fields]="fields"></formly>
      </div>
    </div>
  `
})
export class UploadStepTwoComponent implements OnInit {
  @Input() public code:string;

  public form:UntypedFormGroup = new UntypedFormGroup({});
  public model:{ file:File };
  public fields:IExtraFieldConfigurationObject[];
  public templateUrl:string;
  public loading:boolean;

  private wizard:GaWizard;
  private fileField:IExtraFieldConfigurationObject;

  constructor(
    private formlyService:GaFormlyService,
    private wizardService:GaWizardService,
    private uploadService:UploadService,
    private authService:AuthService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.wizard = this.wizardService.getInstance(UPLOAD_WIZARD);
    this.wizard.title = 'GA.UPLOADS.CHOOSE_FILE';

    // create formly fields
    this.fields = this.createFields();

    this.form.valueChanges.subscribe((model) => this.model = model);
  }

  private onFileChange = (file:File) => {
    this.fileField.templateOptions.hint = file.name;
  };

  private createFields():IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.aGroup(undefined, 'GA.UPLOADS.EXCEL_FILE')
        .withLabelClass('col-sm-3')
        .withValueClass('col-sm-9')
        .withFields([
          this.fileField = this.formlyService.aFileUpload('file', 'GA.UPLOADS.CHOOSE_FILE')
            .withoutWrapper()
            .withUrl(this.authService.authenticatedUrl(`rest/uploads/${this.code}/context`))
            .withWrapperClass('col-sm-12')
            .withLabelClass('col-sm-12')
            .withExtraOptions({
              templateOptions: {
                autoUpload: true,
                uploadContext: { context: JSON.stringify(this.uploadService.model?.context) },
                onUploadDone: (result:IUploadContext) => {
                  // update upload context
                  this.uploadService.model = _.extend(this.uploadService.model, {
                    uploadContext: result,
                    backupUploadContext: result
                  });

                  // change to upload step 3
                  this.wizard.selectStep(UPLOAD_STEP3);
                }
              }
            })
            .onChange(this.onFileChange)
            .build()
        ])
        .build()
    ];
  }
}